import React from "react";
import { Link } from "react-router-dom";
// import Loading from "./Loading";
import "../css/blogcontainer.css";



function SmallArticleItem(props) {

  return (
    <>
      <div className="smallbox">
        <Link to={`/blog/${props.slug}`}>
          <div className="smallimagediv">
            <img
              src={props.imglink}
              alt="article material"
              loading="lazy"
            />
           
          </div>
          <div className="smallarticletitle">{props.title}</div>
          {/* <div className="smallarticledescription">
              {props.description}
          </div> */}
        </Link>
      </div>
    </>
  );
}

export default SmallArticleItem;
